function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 4.667H.5V7h1.75v7h2.917V7H7.29L7.5 4.667H5.167v-.973c0-.557.112-.777.65-.777H7.5V0H5.279C3.18 0 2.25.923 2.25 2.692v1.975z",
  fill: "currentColor"
});

var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 14",
    fill: "none"
  }, props), _ref);
};

export default SvgSocialFacebook;